import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Helpers from "commons/helpers";
import Constants from "constants/index";
import Screens from "constants/screens";

import { LoadingLayout } from "layout";
import { useAuth } from "providers/authProvider";

const LoginRedirectScreen = () => {
    const auth = useAuth();
    const navigate = useNavigate();
    useEffect(() => {
        const user = auth.user;
        if (user) {
            const url = Helpers.getItemInLocalStorage(Constants.StorageKeys.FIRST_URL) || Screens.HOME;
            const from = Helpers.getItemInLocalStorage(Constants.StorageKeys.FROM) || url;
            navigate(from);
        } else if (user === null) {
            auth.signinRedirect();
        }
    }, [auth.user]);

    return <LoadingLayout />;
};

export default LoginRedirectScreen;
